import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import _, { sortBy, uniqBy, map } from 'lodash';
import {
    clearNotification,
    getAllOrderableGameItems,
    getUserRetailerSuggestedOrders,
    initGameList,
    toggleImpersonateRetailer,
} from '../../redux/actions';
import { formatMoney } from '../../constants/utils';
import Page from '../../layout/Page';
import GameCatalog from '../../components/gameCatalog/GameCatalog';
import './styles.css';

export class GameCatalogPage extends Component {
    async componentDidMount() {
        if (!this.props.isImpersonateRetailer) {
            this.props.toggleImpersonateRetailer(false);
            await this.init();
        } else {
            this.props.toggleImpersonateRetailer(true);
        }

        const retailer = this.props.selectedValues?.[0];

        if (retailer && retailer.reference && retailer.jurisdiction) {
            this.props.getUserRetailerSuggestedOrders(
                retailer.reference,
                retailer.jurisdiction.code
            );
        }
    }

    init = async () => {
        const retailerType =
            this.props.retailerInfo && this.props.retailerInfo.type;
        const jurisdiction = this.props.retailerInfo?.jurisdiction?.code;
        await this.props.onGetGameData(
            retailerType && retailerType.reference,
            jurisdiction,
        );
    };

    async componentDidUpdate(prevProps) {
        if (this.props.retailerInfo !== prevProps.retailerInfo) {
            await this.init();
        }

        if (this.props.selectedValues !== prevProps.selectedValues) {
            const retailer = this.props.selectedValues?.[0];

            if (retailer && retailer.reference && retailer.jurisdiction) {
                this.props.getUserRetailerSuggestedOrders(
                    retailer.reference,
                    retailer.jurisdiction.code
                );
            }
        }
    }

    componentWillUnmount() {
        this.props.clearNotifications();
        this.props.initGameList();
        this.props.toggleImpersonateRetailer(false);
    }

    formatPrice = (price) => formatMoney(price);

    getHeaderList = () => {
        let data = uniqBy(
            map(sortBy(this.props.orderableGames, 'price'), (game) => {
                if (game.gameType === 'PS') {
                    return {
                        name: 'POS',
                        id: game.gameType,
                    };
                } else {
                    return {
                        name: this.formatPrice(game.price),
                        id: game.price,
                    };
                }
            }),
            'name',
        );
        try {
            const index = data.findIndex((item) => item.name === 'POS');
            if (index !== -1) {
                const posItem = data[index];
                data.splice(index, 1);
                data.splice(data.length, 0, posItem);
            }
        } catch (e) { }
        return data;
    };

    formatHeaderText = (game) => formatMoney(game.price);

    render() {
        const {
            loading,
            orderableGames,
            suggestedQuantity,
            games,
            isEditOrder,
            parentModalRef,
        } = this.props;
        const themes = _.uniqBy(games, function (game) {
            return game.themeName;
        });
        const gamesList = this.getHeaderList();
        return (
            <Page
                className="game-list"
                name="GameCatalogPage"
                data-testid="GameCatalogPage">
                <Dimmer active={loading} page>
                    <Loader />
                </Dimmer>
                <GameCatalog
                    headerList={gamesList}
                    games={orderableGames}
                    themes={themes}
                    suggestedQuantity={suggestedQuantity}
                    groupByProp="formatedPrice"
                    groupByPropForPos="headerText"
                    sortByProp="gameRefAndName"
                    headerKey={this.formatHeaderText}
                    stickyHeader={true}
                    isEditOrder={isEditOrder}
                    parentModalRef={parentModalRef}
                />
            </Page>
        );
    }
}

const mapStateToProps = ({
    auth,
    gameItems: { filteredGames, content, loading },
    userInfo: { retailerInfo },
    suggestedQuantity,
    retailerSelect: { selectedValues },
}) => {
    return {
        auth,
        orderableGames: filteredGames,
        games: content,
        loading: loading,
        retailerInfo,
        suggestedQuantity: suggestedQuantity.suggestedQuantityMap,
        selectedValues,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetGameData: (retailerType, jurisdiction) =>
            dispatch(getAllOrderableGameItems(retailerType, jurisdiction)),
        clearNotifications: () => dispatch(clearNotification()),
        initGameList: () => dispatch(initGameList()),
        getUserRetailerSuggestedOrders: (reference, jurisdiction) =>
            dispatch(getUserRetailerSuggestedOrders(reference, jurisdiction)),
        toggleImpersonateRetailer: (value) =>
            dispatch(toggleImpersonateRetailer(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GameCatalogPage);
